import React from 'react';
import { Col } from 'reactstrap';
import { MdPayment } from 'react-icons/md';

const AddPaymentBtn = ({ onClick }) => {
  return (
    <Col xs='12' md='12'>
      <button type='button' onClick={onClick} className='btn btn-outline-primary'>
        {' '}
        <MdPayment /> Add a payment method{' '}
      </button>
    </Col>
  );
};

export default AddPaymentBtn;
